module.exports = __webpack_public_path__ + "img/gw.ef19b7dd.svg";